<template>
  <el-breadcrumb
    :class="['y-breadcrumb', theme]"
    :separator-icon="ArrowRight"
    v-bind="$attrs"
  >
    <el-breadcrumb-item
      v-for="(item, index) in routes"
      :key="index"
      :to="item.to"
      @click="item.onClick"
    >
      {{ item.title }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script setup>
import { ArrowRight } from "@element-plus/icons-vue";
defineProps({
  routes: {
    type: Array,
    default: () => []
  },
  theme: String
});
defineOptions({
  name: "Breadcrumb"
});
</script>
<style lang="scss" scoped>
.y-breadcrumb {
  --el-text-color-regular: #fff;
  --y-breadcrumb-page-color: #fff;
  color: var(--y-breadcrumb-color, #fff);
  font-weight: 500;
  font-size: 13px;
  position: absolute;
  left: 0;
  :deep(.el-breadcrumb__item[aria-current="page"]) {
    .el-breadcrumb__inner {
      color: var(--y-breadcrumb-page-color);
    }
  }
  :deep(.el-breadcrumb__inner) {
    color: var(--y-breadcrumb-color, #fff);
    cursor: pointer;
  }
  :deep(.el-breadcrumb__separator) {
    color: var(--y-breadcrumb-color, #fff);
  }
  &.default {
    --el-text-color-regular: #292929;
    color: #292929;
    font-weight: 500;
    font-size: 13px;
    :deep(.el-breadcrumb__inner) {
      color: var(--y-text-default-color);
    }
    :deep(.el-breadcrumb__separator) {
      color: var(--y-text-default-color);
      font-size: 12px;
    }
    :deep(.el-breadcrumb__item[aria-current="page"]) {
      .el-breadcrumb__inner {
        color: var(--y-text-color);
        font-family: var(--y-regular-font);
      }
    }
    .el-breadcrumb__item {
      cursor: pointer;
    }
  }
  &.dark {
    position: relative;
    --y-breadcrumb-color: #696969;
    --y-text-default-color: var(--y-breadcrumb-color);
    --el-text-color-regular: #292929;
    --y-text-color: #292929;
    font-size: 16px;
    line-height: 1em;
    :deep(.el-breadcrumb__separator.el-icon) {
      background: url(https://qiniu-uploads-cdn.charmdeer.com/FomFmhlTXrbbJKJ6dEe9qjKhuG8i_88.svg);
      width: 6px;
      height: 10px;
      background-size: 100% 100%;
      margin: 0 12px;
    }
    :deep(.el-breadcrumb__separator.el-icon svg) {
      display: none;
    }
  }
}
</style>
